import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
 public currentDate: Date;
 public currentYear: number;
  constructor() { }

  ngOnInit() {  
     // Get the current date
     this.currentDate = new Date(); 

    // Extract the year from the date
    this.currentYear = this.currentDate.getFullYear();
  }

}
